import React from 'react';
import styled from 'styled-components';
import map from 'lodash/map';

import languages from '../hooks/languages';

const MainWrapper = styled.div`
  margin: 0 1rem;
`;

const LanguageLabel = styled.div`
  color: #888;
  font-weight: 100;
  text-decoration: none;
  transition: all ease-in 0.15s;
  cursor: pointer;
  padding: 0.6em;
  text-align: center;
  min-width: 1.3rem;
  user-select: none;

  :hover {
    color: #333;
  }
`;

const LanguageList = styled.div`
  position: absolute;
  background-color: #fff;
  box-shadow: 2px 2px 5px #888;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 100;

  ${MainWrapper}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;

const LanguagePicker = ({
  language: currentLanguage,
  setLanguage,
  translate,
}) => {
  const onSelectLanguage = (lang) => () => {
    setLanguage(lang);
  };

  return (
    <MainWrapper>
      <LanguageLabel title={translate('lng_name')}>
        {currentLanguage.toUpperCase()}
      </LanguageLabel>
      <LanguageList>
        {map(languages, (_, key) => (
          <LanguageLabel
            onClick={onSelectLanguage(key)}
            title={translate('lng_name', { lng: key })}
            key={key}
          >
            {key.toUpperCase()}
          </LanguageLabel>
        ))}
      </LanguageList>
    </MainWrapper>
  );
};

export default LanguagePicker;
